// ----------------------------------------------------------------------




export const account = {
  displayName: 'OES Organization',
  email: 'placedealsonkart@gmail.com',
  photoURL: '/assets/images/avatars/avatar_25.jpg',
};
